import axios from 'axios';

export function getTrackedAssetAnalytics(trackedAssetsList) {

  const endpoint = `${process.env.REACT_APP_TRACKED_ASSET_API}`;
  const payload = {
    data: trackedAssetsList,
  };
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.post(endpoint, payload, headers)
    .then(response => {
      return response.data.data;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/tracked-assets-analytics-service.js
 **/